import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByType',
  pure:true
})
export class FilterByTypePipe implements PipeTransform {

  transform(items: any[], filter: {type: string, userId: string }): any[] {
    if (!items) return [];
    if (!filter) return items;
    let filteredItems = items;
    let innerFlag:boolean=false;
if(filter.type==='other'){
  filteredItems = filteredItems.filter(item => item.type !== 'assignment');
  return filteredItems.reverse();
}

    if(filter.type==='invite'){
     innerFlag=true;
     filter.type='own'
    }
    else{
      innerFlag=false;
    }
    if(filter.type==='all'){
      filteredItems = filteredItems.filter(item => item.type !== 'assignment');
    }
    else{
    if (filter.type) {
      filteredItems = filteredItems.filter(item => item.type === filter.type);
    }
    if (filter.userId && filter.type!=='assignment' && !innerFlag) {
      filteredItems = filteredItems.filter(item => item.user_id === filter.userId);
    }
    if (filter.userId && filter.type!=='assignment' && innerFlag) {
      filteredItems = filteredItems.filter(item => item.user_id !== filter.userId);
    }
  }
    // if (filter.userId && filter.type!=='assignment' && !innerFlag) {
    //   filteredItems = filteredItems.filter(item => item.user_id === filter.userId);
    // }

    return filteredItems.reverse();
  }


}